import styled, { css } from 'styled-components';

import { device } from 'styles/breakpoints';

const ValuationWrapper = styled.div<{ isSectionTwo: boolean }>`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: url('/static/images/home-valuation/hero.webp');
  background-size: cover;
  background-repeat: no-repeat;
  color: #fff;
  padding-top: 95px;

  @media ${device.tablet} {
    padding-top: 64px;
  }

  @media ${device.mobile} {
    background: url('/static/images/home-valuation/hero-mobile.webp');
    background-size: cover;
    background-repeat: no-repeat;
  }

  ${({ isSectionTwo }) =>
    isSectionTwo &&
    css`
      background: none !important;
    `}
`;

const Heading = styled.h1<{ isMobileStepTwo: boolean }>`
  font-family: ${({ theme }) => theme.typography.fontFamily.Inter};
  font-size: 43px;
  margin: 40px 0 20px;
  padding: 0 70px;

  @media ${device.laptop} {
    padding: 0 30px;
  }

  @media ${device.tablet} {
    font-size: ${({ isMobileStepTwo }) => (isMobileStepTwo ? '25px' : '40px')};
    text-align: center;
    padding: 0 20px;
  }
`;

const FormAndWidgetWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  padding: 0 130px 20px 70px;

  @media ${device.laptop} {
    padding: 0 30px 20px;
  }

  @media ${device.tablet} {
    flex-direction: column;
    padding: 0 20px 20px;
  }
`;

interface WidgetSectionProps {
  hasWidgetLoaded: boolean;
}

const FormWrapper = styled.div`
  width: 466px;

  @media ${device.tablet} {
    width: 100%;
    margin-top: 20px;
  }
`;

const WidgetSection = styled.div<WidgetSectionProps>`
  display: flex;
  justify-content: center;
  white-space: initial;
  position: relative;
  min-height: ${({ hasWidgetLoaded }) => (hasWidgetLoaded ? '460px' : '650px')};

  @media ${device.tablet} {
    width: 100%;
    align-self: center;
  }
`;

const WidgetOverlayImage = styled.div`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export default {
  ValuationWrapper,
  Heading,
  FormAndWidgetWrapper,
  FormWrapper,
  WidgetSection,
  WidgetOverlayImage,
};
